import React from 'react'; 
import ReactDOM from 'react-dom/client';
import CreateReactClass from "create-react-class";

export var Action = CreateReactClass({
  displayName: "Action",
    getDefaultProps: function getDefaultProps() {
    return {
      number : 0
    };
  },  
  //untuk tambah likes function
_handleKeyPress: function _handleKeyPress(e) {

//to prevent doublereentering of likes.
if (this.props.number == 0) {
//future problem, cause it take another round of clips to get the array here.
var bool = JSON.parse(localStorage.getItem("container"));
bool[1] = bool[1].substring(0, bool[1].length-1);
var num = bool[1].split(",");
var id = bool[0].concat(num.length -1);
  var box = "post_id="+id;
  console.log(box);
  var xhttp = new XMLHttpRequest();
  
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      console.log(this.responseText);
      //container = this.responseText;

    }
  };

  xhttp.open("POST", "php/keyin02.php", true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhttp.withCredentials = true;
  xhttp.send(box);

  document.getElementById(id).innerHTML = parseInt(document.getElementById(id).innerHTML) + 1;
  this.props.number = 1;
}
  },
  render: function render() {
    return React.createElement(
      "p",
      { className: "action-button" ,onClick: this._handleKeyPress},
      this.props.text
    );
  }
});


export var Hour = CreateReactClass({
  displayName: "Hour",

  getDefaultProps: function getDefaultProps() {
    return {
      time: 42
    };
  },

  render: function render() {
    return React.createElement(
      "p",
      null,
      this.props.time,
      " h"
    );
  }
});


var Comment = CreateReactClass({
  displayName: "Comment",

  getDefaultProps: function getDefaultProps() {
    return { name: "Douglas Adams"
     };
  },
  getfunction1: function getfunction1() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const group_id = urlParams.get('id')
    window.location.href = "./profile/profile.php?id="+group_id+"&name="+this.props.value;
  },
  render: function render() {
    return React.createElement(
      "div",

      { className: "single-comment" },
      React.createElement("div",{className: "Container_Comment_image_pastor"},
      React.createElement("img", {style: {backgroundImage: this.props.url}})),
      React.createElement(
        "div",
        { className: "single-container" },
        React.createElement(
          "a",
          {className:"single-container_name_pastor", onClick:this.getfunction1,href:"#"},
          this.props.name
        ),
        React.createElement(
          "p",
          {className:"single-container_p"},
          this.props.children
        )
      ),
      React.createElement(
        "div",
        { className: "buttons" },
        React.createElement(Action, { text: "Like!" }),
        React.createElement(Action, { text: "Respond" }),
        React.createElement(Hour, { time: this.props.time })
      )
    );
  }
});

export function loadpost_pastor(id,I_comment, I_name) {

var mains = document.createElement("DIV");
mains.id = "container_app_2";
mains.style.animation = "fadein 0.5s ease-in";
//contoh
console.log("apa la lagi"+id);
var id = id.concat("_C");
document.getElementById(id).appendChild(mains);

var temp_name = I_name.replaceAll("_"," ");
//document.body.insertBefore(mains,document.getElementById(id).nextSibling);
//localStorage.setItem("id",id);

var P_recursive = CreateReactClass({
  
  displayName: "Hour",

  getDefaultProps: function getDefaultProps() {
    return {
      time: 42
    };
  },

  render: function render() {
    return React.createElement(
          Comment,
          { name: temp_name, time: 3,url: "url(./profile/assets/php/"+I_name+"_front.png)",value:I_name },
          I_comment
        );
  }
});

var container = React.createElement(
  "div",
  null,
  React.createElement(P_recursive, null)
  )

ReactDOM.render(container, mains);
}